/**
 * Central image asset map — ALL images extracted from Figma.
 * Zero CDN dependencies. Replace with API URLs when going dynamic.
 */

const APP_BASE = process.env.PUBLIC_URL;

const A = `${APP_BASE}/assets/images/`;

const ASSETS = {
  // Backgrounds
  heroBg: A + "hero-bg.jpg",
  profileCover: A + "profile-cover.jpg",

  // Logo
  logo: A + "logo.jpg",

  // Doves (landing page decorations & about page)
  doves: A + "doves.png",
  doveDark: A + "dove-dark.jpg",
  doveDark2: A + "dove-dark2.jpg",

  // Post / Feed
  postSpiritual: A + "post-spiritual.jpg",

  // Community
  communityForest: A + "community-forest.jpg",
  communityMountains: A + "community-mountains.jpg",

  // About
  aboutGroup: A + "about-group.jpg",

  // FaithStream media thumbnails (from Figma Faith Stream page)
  mediaCounseling: A + "media-counseling.jpg",
  mediaMentoring: A + "media-mentoring.jpg",

  // Auth pages
  authRight: A + "auth-right.png",

  // Avatars — mapped to exact Figma positions
  avatarSavannah: A + "avatar-savannah.jpg",
  avatarDarlene: A + "avatar-darlene.jpg",
  avatarAlbert: A + "avatar-albert.jpg",
  avatarRobert: A + "avatar-robert.jpg",
  avatarKathryn: A + "avatar-kathryn.jpg",
  avatarDevon: A + "avatar-devon.jpg",
  avatarCourtney: A + "avatar-courtney.jpg",
  avatarCourtneyHenry: A + "avatar-courtney-henry.jpg",
  avatarDianne: A + "avatar-dianne.jpg",
  avatarGuy: A + "avatar-guy.jpg",
  avatarBrotherJulian: A + "avatar-brother-julian.png",
  avatarAisha: A + "avatar-aisha.jpg",

  // Story circle avatars
  storyDavid: A + "avatar-story-david.jpg",
  storySarah: A + "avatar-story-sarah.jpg",
  storyJames: A + "avatar-robert.jpg",
  storyAisha: A + "avatar-aisha.jpg",
};

export default ASSETS;
